/**
 * Certificate sharing (FEAT-007): all current certificates of one organisation — approved systems of a
 * supplier, or licenses of a coater — shared by email or downloaded as a ZIP.
 */
export type CertificateSharingKind = 'approved-systems' | 'licenses';

export interface CertificateSharingLabels {
  /** "Approval No." / "License No." */
  reference: string;
  /** "System" / "Production site" */
  description: string;
  /** "Type" */
  category: string;
  /** "supplier organisation" / "coater" */
  organisation: string;
}

export const CERTIFICATE_SHARING_LABELS: Record<CertificateSharingKind, CertificateSharingLabels> = {
  'approved-systems': { reference: 'Approval No.', description: 'System', category: 'Type', organisation: 'Supplier organisation' },
  licenses: { reference: 'License No.', description: 'Production site', category: 'Type', organisation: 'Coater' },
};

export interface ShareableOrganisation {
  organisationId: string;
  name: string;
  organisationType?: string;
  assignedGlName?: string;
  certificateCount: number;
}

export interface SharePreviewCertificate {
  entityId: string;
  reference: string;
  description?: string;
  category?: string;
  state?: string;
  expiryDate?: string;
  documentId: string;
  fileName: string;
  issuedOn: string;
}

export interface SharePreviewContact {
  id: string;
  displayName: string;
  email: string;
  isCertificateRecipient: boolean;
  preselected: boolean;
}

export interface OrganisationCertificatePreview {
  organisationId: string;
  organisationName: string;
  certificates: SharePreviewCertificate[];
  contacts: SharePreviewContact[];
}

export interface ShareOrganisationCertificatesRequest {
  contactIds: string[];
  additionalEmails: string[];
}

export interface ShareOrganisationCertificatesResponse {
  certificateCount: number;
  recipientCount: number;
  expiresOn: string;
}

/** Dialog data of ShareCertificatesDialogComponent */
export interface ShareCertificatesDialogData {
  kind: CertificateSharingKind;
}
